





























































































































































































































































































import { Vue, Component, Ref, Watch } from 'vue-property-decorator'
import { FormPlugin, Loja, Page, Pageable } from '@/models'
import { FindLojaUseCase } from '@/usecases'
import axios, { CancelTokenSource } from 'axios'
import { LojaModule } from '@/store/vuex/loja/LojaStore'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import ListagemDeLojasPorLista from '@/components/loja/ListagemDeLojasPorLista.vue'
import * as pluginApi from '@/api/plugin'
import { downloadFilesFromS3, uploadFilesToS3 } from '@/shareds/s3/files'
import PluginModule from '@/store/vuex/aplicacao/PluginStore'


@Component({
	components: {
		ListagemDeLojasPorLista,
	},
})
export default class DialogoDeEdicaoDePlugin extends Vue {
	@Ref() form!: HTMLFormElement

	plugin: FormPlugin | null = null
	mostra = false
	salvando = false
	baixandoDoc = false
	enviandoDoc = false
	salvandoPorLoja = false
	selecionado = null
	chave = ''
	valor = ''

	chavePorLoja = ''
	valorPorLoja = ''

	tab = null
	buscandoLojas = false
	pagina: Page<Loja> | null = null
	paginado: Pageable = {
		page: 0,
		size: 5,
		sort: [],
	}
	cancelToken: CancelTokenSource | null = null
	findLojaUseCase = new FindLojaUseCase()
	termoBusca = ''
	mostrarConfigPorLoja = false

	lojaSelecionada: Loja | null = null
	PluginModule = PluginModule

	get configs() {
		if (this.plugin) {
			return Object.entries(this.plugin?.configs).map(([chave, valor]) => {
				return { chave, valor }
			})
		}
		return []
	}

	get configsDaLoja() {
		if (!this.lojaSelecionada) return []
		if (!this.plugin) return []
		if (!this.plugin.configsPorLoja) return []

		return this.plugin.configsPorLoja.filter(config => config.lojaId === this.lojaSelecionada?.id)
	}

	adicionarConfig() {
		if (this.plugin) {
			this.$set(this.plugin.configs, this.chave, this.valor)
			this.chave = ''
			this.valor = ''
		}
	}

	adicionarConfigPorLoja() {
		if (this.plugin && this.plugin.id && this.lojaSelecionada) {
			this.plugin.configsPorLoja.push({
				pluginId: this.plugin.id,
				lojaId: this.lojaSelecionada.id,
				chave: this.chavePorLoja,
				valor: this.valorPorLoja,
			})
			this.chavePorLoja = ''
			this.valorPorLoja = ''
		}
	}

	excluirConfig(chave) {
		if (this.plugin) {
			this.$delete(this.plugin.configs, chave)
		}
	}

	alterarConfig(chaveValor) {
		if (this.plugin) {
			this.$set(this.plugin.configs, chaveValor.chave, chaveValor.valor)
		}
	}

	excluirConfigDaLoja(configId) {
		if (!this.plugin) return

		const indice = this.plugin.configsPorLoja.findIndex(config => config.id === configId)
		this.plugin.configsPorLoja.splice(indice, 1)
	}

	mostrar(plugin: FormPlugin) {
		this.plugin = plugin
		this.mostra = true
		this.buscar()

		setTimeout(() => {
			this.form.resetValidation()
		})
	}

	esconder() {
		this.mostra = false
	}

	salvar() {
		const plugins = PluginModule.plugins
		const outrosPluginsDeMensageriaAtivos = plugins.filter(
			plugin => plugin.mensageria === true && plugin.ativo && plugin.id !== this.plugin?.id,
		)
		if (this.plugin?.ativo && this.plugin?.mensageria && outrosPluginsDeMensageriaAtivos.length > 0)
			return AlertModule.setError("Permitido somente um plugin de mensageria configurado ativo.")

		if (this.plugin && this.chave != '' && this.valor != '') {
			this.$set(this.plugin.configs, this.chave, this.valor)
			this.chave = ''
			this.valor = ''
		}
		this.mostra = false
		this.$emit('confirmado', this.plugin)
	}

	async pageNext() {
		this.paginado = {
			...this.paginado,
			page: (this.paginado?.page || 0) + 1,
		}

		await this.buscar()
	}

	async pagePrevious() {
		this.paginado?.page
			? this.paginado.page -= 1
			: this.paginado.page = 0
		await this.buscar()
	}

	async buscar() {
		try {
			this.buscandoLojas = true
			if (this.cancelToken) this.cancelToken.cancel()
			this.cancelToken = axios.CancelToken.source()
			this.pagina = await this.findLojaUseCase.find({
				page: this.paginado.page || 0,
				size: this.paginado.size || 5,
				busca: this.termoBusca || undefined,
				lojasDoGrupoDoUsuario: true,
				// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
				idUsuario: JSON.parse(localStorage.getItem('USUARIO_LOGADO')!).id,
			},
			{
				cancelToken: this.cancelToken.token,
			})
			this.paginado.page = this.pagina.number
			LojaModule.setLojas(this.pagina.content)
		} catch (error: any) {
			if (axios.isCancel(error)) return
			this.pagina = null
			AlertModule.setError(error)
		} finally {
			this.buscandoLojas = false
		}
	}

	get lojas() {
		return LojaModule.lojasOrdenadas
	}

	get abaLateral() {
		return this.$vuetify.breakpoint.xs || this.$route.name !== 'Lojas'
	}

	@Watch('termoBusca')
	setTermo() {
		this.paginado.page = 0;
		this.buscar()
	}

	abrirConfiguracaoDaLoja(loja: Loja) {
		this.lojaSelecionada = loja
		this.mostrarConfigPorLoja = true
	}

	async fecharConfigPorLoja() {
		if (!this.plugin) return
		try {
			this.salvandoPorLoja = true
			const configs = await this.salvarConfigPorLoja()

			this.plugin.configsPorLoja = this.plugin.configsPorLoja.filter(config => config.lojaId !== this.lojaSelecionada?.id)

			configs?.forEach(config => {
				if (!this.plugin) return

				this.plugin.configsPorLoja.push(config)
			})

			this.mostrarConfigPorLoja = false
			this.lojaSelecionada = null
			this.selecionado = null
			this.chavePorLoja = ''
			this.valorPorLoja = ''
		} catch(error) {
			AlertModule.setError(error)
		} finally {
			this.salvandoPorLoja = false
		}
	}

	async baixarDocMensageria() {
		try {
			this.baixandoDoc = true
			await downloadFilesFromS3('pdfs', 'doc-mensageria-almode.pdf')
		} catch (error: any) {
			AlertModule.setError('Houve um problema ao baixar a documentação')
		} finally {
			this.baixandoDoc = false
		}
	}

	abrirUploadDoc() {
		(this.$refs.inputDocMensageria as HTMLInputElement).click()
	}

	async uploadDocMensageria(event: Event) {
		const input = event.target as HTMLInputElement
		const arquivo = input.files?.[0]
		if (!arquivo) return
		try {
			this.enviandoDoc = true
			const fileComNomeFixo = new File([arquivo], 'doc-mensageria-almode.pdf', { type: arquivo.type })
			await uploadFilesToS3([fileComNomeFixo], 'pdfs')
			AlertModule.setSuccess('Documentação enviada com sucesso')
		} catch (error: any) {
			AlertModule.setError('Houve um problema ao enviar a documentação')
		} finally {
			this.enviandoDoc = false
			input.value = ''
		}
	}

	async cancelarConfigPorLoja() {
		this.mostrarConfigPorLoja = false
		this.lojaSelecionada = null
		this.selecionado = null
		this.chavePorLoja = ''
		this.valorPorLoja = ''
	}

	async salvarConfigPorLoja() {
		if (!this.plugin || !this.plugin.id || !this.lojaSelecionada) return

		if (this.plugin && this.plugin.id && this.lojaSelecionada) {
			this.plugin.configsPorLoja.push({
				pluginId: this.plugin.id,
				lojaId: this.lojaSelecionada.id,
				chave: this.chavePorLoja,
				valor: this.valorPorLoja,
			})
			this.chavePorLoja = ''
			this.valorPorLoja = ''
		}

		const configsPorLoja = this.plugin.configsPorLoja.filter(config => config.lojaId === this.lojaSelecionada?.id)

		return pluginApi.updateConfigsPorLoja(this.plugin.id, this.lojaSelecionada.id, configsPorLoja)
	}
}
